export default "__VITE_ASSET__7b4442f2__"